import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const ChartContainer = styled.div`
  position: relative;
  width: 100%;

  .highcharts-series {
    cursor: pointer;
  }

  .stacked-bar-xaxis-hidden {
    display: none;
  }

  .highcharts-series-inactive {
    opacity: 1;
  }

  .highcharts-plot-band,
  .highcharts-pane {
    fill: ${colors.grey1};
    fill-opacity: 1;
  }

  .stacked-bar-tooltip--item {
    display: flex;
  }

  .stacked-bar-plotband {
    fill: ${colors.black};
    fill-opacity: 0;
    cursor: pointer;
    transform: scaleY(2) translateY(-5px);
  }

  .stacked-bar-plotband.stacked-bar-plotband__hover {
    stroke: ${colors.grey3};
    stroke-width: 1px;
  }

  .stacked-bar-plotband--selected {
    transform: scaleY(2) translateY(-5px);
  }

  .highcharts-container.bar-chart {
    overflow: auto;
  }

  .highcharts-column-series rect.highcharts-point {
    rx: 0;
  }
`;
